if (!customElements.get('grouped-image-with-text')) {
  customElements.define('grouped-image-with-text', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.frames = Array.from(this.querySelectorAll('[data-group-image]'));
      this.panels = Array.from(this.querySelectorAll('[data-group-copy]'));
      this.interval = Math.max(1000, Number(this.dataset.interval) || 3000);
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.editorSelected = false;
      this.focused = this.contains(document.activeElement);
      this.request = (this.request || 0) + 1;
      this.index = 0;
      this.cursor = 0;
      this.activeGroup = null;
      if (!this.frames.length) return;

      this.show(0);
      this.motionPreference.addEventListener('change', () => this.start(), options);
      document.addEventListener('visibilitychange', () => this.start(), options);
      // Keep a focused group's link stable while the visitor uses the keyboard.
      this.addEventListener('focusin', () => {
        this.focused = true;
        this.stop();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (this.contains(event.relatedTarget)) return;
        this.focused = false;
        this.start();
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.frames.findIndex((frame) => frame.dataset.groupId === event.detail.blockId);
        if (index < 0) return;
        this.editorSelected = true;
        this.stop();
        this.goTo(index);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.editorSelected = false;
        this.start();
      }, options);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.abortController?.abort();
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
      this.request += 1;
    }

    start() {
      this.stop();
      if (!this.isConnected || this.frames.length < 2 || this.motionPreference.matches || this.editorSelected || this.focused || document.hidden) return;
      // The cursor advances on failure too, so a broken image cannot block later groups.
      this.timer = setInterval(() => this.goTo((this.cursor + 1) % this.frames.length), this.interval);
    }

    async goTo(index) {
      if (index < 0 || index >= this.frames.length) return;
      this.cursor = index;
      const request = ++this.request;
      const image = this.frames[index].querySelector('img');
      if (image) {
        image.loading = 'eager';
        try {
          await image.decode();
        } catch {
          if (!image.complete || !image.naturalWidth) return;
        }
      }
      if (!this.isConnected || request !== this.request) return;
      this.show(index);
    }

    show(index) {
      this.index = index;
      this.cursor = index;
      this.frames.forEach((frame, frameIndex) => {
        const active = frameIndex === index;
        frame.classList.toggle('is-active', active);
        frame.setAttribute('aria-hidden', String(!active));
        frame.inert = !active;
      });
      const groupId = this.frames[index].dataset.groupId;
      // Do not mutate or animate copy/links while advancing within the same group.
      if (groupId !== this.activeGroup) {
        this.panels.forEach((panel) => {
          const active = panel.dataset.groupCopy === groupId;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
        this.activeGroup = groupId;
      }
      const nextImage = this.frames[(index + 1) % this.frames.length].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
    }
  });
}
